export const selectCases = (state) => state.cases;

export const selectCaseList = (state) => state.cases.list;
export const selectCaseListLoading = (state) => state.cases.loading;
export const selectCaseLoadingCount = (state) => state.cases.loadingCount;
export const selectCaseListError = (state) => state.cases.error;
export const selectCaseFilters = (state) => state.cases.filters;